exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".locale-time--input[data-v-5eeae2d1] {\n  border: 0;\n  box-shadow: 0;\n  background: transparent;\n  padding: 0;\n  margin-left: -1px;\n}\n", ""]);

// exports
